import axios from "axios";

export default {
    namespaced: true,
    state: {},
    mutations: {},
    getters: {},
    actions: {
        async autocomplete(ctx, { query, countries, limit, permanent = false }) {
            return axios.get("/api/v1/geocode/autocomplete", {
                params: {
                    q: query,
                    c: countries,
                    limit,
                    permanent,
                },
            });
        },
        async reverse(ctx, { lat, lng, countries, limit }) {
            return axios.get("/api/v1/geocode/reverse", {
                params: {
                    lat,
                    lng,
                    c: countries,
                    limit,
                },
            });
        },
    },
};
